import { IChildProp } from "@intelligence/components/Form/type";
import { convertDataSourceAndSource } from "@intelligence/_config/enumeration/dataSource";

const PC_DATA_SOURCE = {
  steamcharts: ['pcu','acu', 'steamFollowers', 'steamReviews'],
  mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast', 'mscienceLifetimeDigitalRevenue', 'mscienceLifetimeDigitalUnits'],
  databrain: [
    'databrain__total_revenue',
    'databrain__lifetime_total_revenue',
    'databrain__base_game_sales_units',
    'databrain__lifetime_base_game_sales_units',
  ],
  gsd: ['digitalUnitsGSD', 'physicalUnitsGSD', 'digitalRevenueGSD', 'physicalRevenueGSD'],
  npd: ['physicalRevenue', 'physicalUnits'],
  newzoo: ['mau', 'playerShare', 'mauGrowth', 'mauNew', 'mauReturning', 'lifetimePlayer', 'timeSpent0h','timeSpent1h', 'timeSpent5h', 'timeSpent10h', 'timeSpent25h', 'timeSpent50h', 'avgDailyPlaytime', 'avgDailySessions', 'avgPlaytimePerSession', 'avgMonthlyPlaytime', 'avgMonthlySessions', 'avgDaysPlayed', 'stickness', 'totalHours', 'churn', 'acquisition', 'retentionD1', 'retentionD2', 'retentionD4', 'retentionD7', 'retentionD14', 'retentionD28'],
  hatchet: ['hoursWatched', 'airtime', 'peakCCV', 'avgCCV'],
  vginsights: ['premiumRevenue', 'cumulativeRevenue', 'unitVgi', 'cumulativeUits', 'price', 'weightedPrice', 'lifetimeWeightedPrice', 'playersByCountry', 'avgPlaytime', 'totalFollowers'],
};

const getMetricsChildren = () => convertDataSourceAndSource(PC_DATA_SOURCE, {
  disableCondition: {
    gsd: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
    npd: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
    newzoo: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
  },
  disableMsgKey: {
    gsd: 'dbi_info_gsd_metrics_category_disabled_tips',
    npd: 'dbi_info_physical_monthly_only',
    newzoo: 'dbi_info_newzoo_bymonth',
  },
  // 默认权限，convertDataSourceAndSource会过滤禁选的选项
  isDefault: {
    steamcharts: ['pcu'],
    mscience: 'all',
    databrain: 'all',
    gsd: 'all',
    npd: 'all',
    newzoo: 'all',
    hatchet: 'all',
    vginsights: 'all',
  },
});

const PC_DETAIL_STATS_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'mutilMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    children: getMetricsChildren(),
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasSteamId',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        isDefault: true,
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }],
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const PC_DETAIL_STORE_RANK_DOWNLOAD_SET: IChildProp[] = [{
  label: 'Chart',
  labelKey: 'dbi_label_chart',
  value: 'chart',
  type: 'checkboxGroup',
  children: [{
    isDefault: true,
    enumKey: 'steam',
    enumTargetType: 'platformGame',
  }, {
    enumKey: 'epic',
    enumTargetType: 'platformGame',
  }]
}, {
  enumKey: 'basicInformation',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [{
    enumKey: 'hasCompany',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasGenre',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRelease',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRegion',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasSteamId',
    enumTargetType: 'downloadBasicInfo',
  }],
}, {
  enumKey: 'dataCalculationChange',
  enumTargetType: 'downloadMainCategory',
  type: 'switch',
  isDefault: true,
}, {
  enumKey: 'dataAmount',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportAllData',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadOther',
  }]
}, {
  enumKey: 'selectTop',
  enumTargetType: 'downloadMainCategory',
  type: 'inputNumber',
  // 默认值，带?为变量传入，不带为正常值
  defaultValue: '?additionalFields:initialSelectTop',
  condition: 'dataAmount:top',
}, {
  enumKey: 'fileFormat',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportExcel',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'exportCSV',
    enumTargetType: 'downloadOther',
  }],
}];

export default {
  PCDetailStatsAndCountries: PC_DETAIL_STATS_DOWNLOAD_SET,
  PCDetailStoreRank: PC_DETAIL_STORE_RANK_DOWNLOAD_SET
};
